import { lazy, Suspense } from 'react'
import { Route, Switch } from 'wouter'

const MCPAppsPage = lazy(() => import('./MCPAppsPage.tsx'))
const DemoPage = lazy(() => import('./DemoPage.tsx'))
const ProductPageLanding = lazy(() => import('./ProductPageLanding.tsx'))

// Homepage is handled directly by index.html (embed script, no React).
// This App component only runs on sub-routes.
function App() {
  return (
    <Switch>
      <Route path="/demo">
        <Suspense fallback={<div className="min-h-screen bg-white" />}>
          <DemoPage />
        </Suspense>
      </Route>
      <Route path="/mcp-apps">
        <Suspense fallback={<div className="min-h-screen bg-white" />}>
          <MCPAppsPage />
        </Suspense>
      </Route>
      <Route path="/productpage">
        <Suspense fallback={<div className="min-h-screen bg-cream" />}>
          <ProductPageLanding />
        </Suspense>
      </Route>
    </Switch>
  )
}

export default App
